import { render, staticRenderFns } from "./PersonalAccessHistoryIframe.vue?vue&type=template&id=707b8fe3&"
import script from "./PersonalAccessHistoryIframe.vue?vue&type=script&lang=ts&"
export * from "./PersonalAccessHistoryIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports